// @flow
import React from 'react';
import { PillModal } from '@finect/tabular-components/Pills';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';

type Props = {
  onClose: Function
};

// UTMs de campaña que la píldora persiste con el lead (atribución pedida por marketing).
// Van como query params en la URL de la pill: la app del iframe los lee de su propio
// `location.search` y los guarda. PillModal (vía getPillUrlWithReferrer → query-string)
// los conserva y además añade `x-referrer`. Mismo patrón que BankOnboardingCTA.
const PILL_UTMS =
  'utm_source=Finect&utm_medium=boton_perfil_asesores&utm_campaign=asesores&utm_content=boton_perfil_asesores';

/**
 * Píldora `advisers-leads` en un modal, compartida por el banner de cabecera (`ProfileLeadBanner`)
 * y por la barra inferior de móvil/tablet (`ProfileLeadBar`).
 *
 * Centraliza la URL de la píldora, los UTMs de campaña y el `onLogin` para que ambos puntos de
 * captación se comporten igual. El lead queda rastreado con `Pagina_referencia = ` la URL del
 * perfil (PillModal añade el referrer vía `getPillUrlWithReferrer`) y con los UTMs de campaña.
 */
export const LeadPillModal = ({ onClose }: Props) => (
  <PillModal
    pill={`${getSuperPartnerBaseURL()}/pills/es_ES/finect/default/advisers-leads/steps/advisoryObjective?${PILL_UTMS}`}
    onLogin={() => window.postMessage({ status: 'loggedIn' })}
    onClose={onClose}
  />
);
